export default __webpack_public_path__ + "static/media/logo.0f09a0b2.svg";